import { readonly, ref } from 'vue';
import { STOREClientService, Term } from '@/storecontext/shared/api/server-apis';
import utilitiesService from '@/shared/utilities.service';

const termsAndConditions = ref<(Term)[]>([]);

export function useTermsAndConditions() {
    const fetchAndSetTerms = async() => {
        const response = await STOREClientService.getTermsAndConditions().then(utilitiesService.unwrapModel);
        termsAndConditions.value = (response ?? []) as Term[];
    };

    fetchAndSetTerms();

    return {
        termsAndConditions: readonly(termsAndConditions),
    };
}
